"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var styles = function styles(theme) {
  return {
    root: {
      padding: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    avatar: {
      width: '60px',
      height: '60px'
    },
    name: {
      fontSize: '1.2rem',
      textAlign: 'center',
      fontWeight: theme.typography.fontWeightMedium,
      marginTop: theme.spacing(1)
    },
    email: {
      fontSize: '0.8rem',
      textAlign: 'center',
      marginTop: theme.spacing(1) / 2,
      fontWeight: theme.typography.fontWeightLight
    }
  };
};

var _default = styles;
exports.default = _default;